import { router, type Href } from 'expo-router';

import { toHomeTabPath } from '@/util/homeTabPath';

/**
 * Opens a screen that lives in a tab from a screen stacked over the tabs, such as Account or
 * a feedback modal.
 *
 * A push or a replace from there would add a second copy of the whole tab navigator on top of
 * the secure stack, with its own tab bar. Dismissing to the destination pops back to the tabs
 * already underneath and opens the screen inside them, in its home tab.
 */
export function navigateIntoTabs(href: string): void {
  router.dismissTo(toHomeTabPath(href) as Href);
}
